
import { openChat } from '@/data/im'
import getRecommendConsultant from '@/common/consultant/recommend_consultant'
export default {
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async consult (building_id) {
      if (this.loading) {
          return
      }
      this.loading = true
      // this.$bindLogEvt('around-facilities')
      const consultant = await getRecommendConsultant({
          scene: 'building_detail_around_facility',
          building_id,
      })
      if (!consultant || !consultant.id) {
          wx.showToast({
              title: '本楼盘暂无置业顾问哦～',
              icon: 'none',
              duration: 3000
          })
      } else {
          openChat(consultant.id, {
              from: '周边配套',
              building_id
          })
      }
      this.loading = false
    }
  }
}
